// User agent Safari
// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.5.2 Safari/605.1.15
// User agent Chrome/Brave
// Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115.0.0.0 Safari/537.36

export function getKnownBrowser(): { browser: "safari" | undefined; version?: number } {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        // Il est possible d'avoir des userAgent sous la forme : 16.3 sans version mineur
        const res = /Version\/([\d])\.?([\d]?)\.?([\d]?)/i.exec(navigator.userAgent);
        if (!res) {
            return { browser: undefined };
        }
        const [_match, main, _minor, _patch] = res;

        return { browser: "safari", version: Number.parseInt(main, 10) };
    }

    return { browser: undefined };
}
